import { cond, constant, isEqual, stubTrue } from "lodash";
import { ERROR_CODES } from "./types";

export const REQUEST_LIMIT_MESSAGE = "Please wait 30 seconds and try again";

export const INVALID_PHONE_NUMBER_ERROR = "Phone Number is invalid";

export const INVALID_VERIFICATION_NUMBER_ERROR = "Verification Code is invalid";

export const GENERIC_ERROR_MESSAGE =
  "Something went wrong, please try again later";

export const ERROR_MESSAGE_FOR_ERROR_CODES = {
  [ERROR_CODES.TOO_MANY_REQUESTS]: REQUEST_LIMIT_MESSAGE,
  [ERROR_CODES.INTERNAL_ERROR]: GENERIC_ERROR_MESSAGE,
};

export const convertStatusCodeToErrorMessage = (code: number) =>
  cond([
    [
      (code: number) => isEqual(code, ERROR_CODES.TOO_MANY_REQUESTS),
      constant(ERROR_MESSAGE_FOR_ERROR_CODES[ERROR_CODES.TOO_MANY_REQUESTS]),
    ],
    [
      (code: number) => isEqual(code, ERROR_CODES.INTERNAL_ERROR),
      constant(ERROR_MESSAGE_FOR_ERROR_CODES[ERROR_CODES.INTERNAL_ERROR]),
    ],
    [stubTrue, constant(GENERIC_ERROR_MESSAGE)],
  ])(code);
